import { Card } from "../../ds/DS";
import { PageHead } from "./parts";

// Sections whose full build lands in a later phase. The shell, navigation and
// scope model are live now; this keeps every nav item reachable meanwhile.
export function Placeholder({ title }: { title: string }) {
  return (
    <div className="stack-24">
      <PageHead
        eyebrow={title.toUpperCase()}
        title={title}
        sub="This section is part of the redesign and is being built next."
      />
      <Card accent>
        <div className="empty">
          {title} is coming in a later phase of the portal rebuild.
        </div>
      </Card>
    </div>
  );
}
